/**
 * HM-494 Schedina Alloggiati Questura — client API.
 */
import { api } from './client.js';

export type AlloggiatiSchedina = {
  id: string;
  tenantId: string;
  bookingId: string;
  guestId: string;
  status: 'pending' | 'submitted' | 'accepted' | 'rejected';
  guestDataJson: Record<string, unknown>;
  submittedAt: string | null;
  submittedByUserId: string | null;
  receiptId: string | null;
  errorMsg: string | null;
  createdAt: string;
  updatedAt: string;
};

export async function listPendingAlloggiati(): Promise<{
  items: AlloggiatiSchedina[];
  total: number;
}> {
  return api('/alloggiati/pending');
}

export async function listSentAlloggiati(): Promise<{
  items: AlloggiatiSchedina[];
  total: number;
}> {
  return api('/alloggiati/sent');
}

export async function submitAlloggiati(schedinaIds: string[]): Promise<{
  ok: boolean;
  submitted: number;
  accepted: number;
  rejected: number;
  receiptId: string | null;
}> {
  return api('/alloggiati/submit', {
    method: 'POST',
    body: JSON.stringify({ schedinaIds }),
  });
}
